import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TipoEntidadeEnum, TipoRelacao } from '@core/models/entidade';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { EntidadesService } from '@core/services/entidades.service';
import { MessageService } from '@core/services/message.service';
import { ColumnOrder } from '@core/table/order';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { addFormControls, dataComDigitacao } from '@shared/util/util';
import {
  cnpjSuperiorLinha,
  extrairId,
  nomeReduzidoSuperiorLinha,
  nomeSuperiorLinha,
  nomeTipoRelacaoLinha,
  normalizarEntidadeSuperiorParaApi,
  paraIsoOuNull,
  snapshotEntidadeSuperior,
} from '@modules/entidade/pages/entidade-form/entidade-envio.util';
import dayjs from 'dayjs';

@Component({
  selector: 'app-entidade-superior-list',
  templateUrl: './entidade-superior-list.component.html',
  styleUrls: ['./entidade-superior-list.component.scss']
})
export class EntidadeSuperiorListComponent implements OnInit, OnChanges {

  @Input() entidadeForm!: FormGroup;
  @Input() data: any;
  @Input() nomePagina: NomePaginaEnum = NomePaginaEnum.ENTIDADE;

  @Input() tipoEntidadeSelecionada!: any;
  @Input() tipoEntidadeList!: any;
  entidadeSuperioresForm!: FormGroup;

  idParams!: number;
  editar: boolean = false;
  desvincular: boolean = false;
  vincular: boolean = false;

  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  columOrder: ColumnOrder | undefined;
  nzFilterOption = (): boolean => true;

  entidadeSuperiorList: any;
  entidadeSuperiorListFiltrado: any;

  @Input() tipoRelacaoList: any[] = [];
  idTipoRelacaoEntidadeSelecionada: any;
  isOrganizacao: boolean = false;

  isShowDataAssociacao: boolean = false;
  isShowDataDesassociacao: boolean = false;
  entidadeSuperiorSelecionada: any;
  indexItemAtual: number | undefined;

  campoVazio:any

  dataAssociacaoInvalida:any

  @Input() somenteVisualizar!: any;
  @Input() inserir!: boolean;

  constructor(
    private entidadesService: EntidadesService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.carregarTabela();
      this.entidadesService.getEntidadeSuperiores().subscribe(entidadesSuperiores =>this.entidadeSuperiorList = entidadesSuperiores);
    }
    this.entidadeSuperioresForm?.valueChanges?.subscribe(() => {
      if(this.entidadeSuperioresForm.get('dataAssociacao')?.value !== ''){
        this.dataAssociacaoInvalida = false
      }
    })
  }

  ngOnInit() {
    this.construirForm();
    this.idParams = this.route.snapshot.params['id'] ?? null;


  }

  construirForm() {
    const nomeObs = (this.nomePagina || NomePaginaEnum.ENTIDADE) + 'Superiores';
    if (!this.entidadeForm.get(nomeObs)) {
      addFormControls(this.entidadeForm, {
        [nomeObs]: [[]],
      });
    }

    this.entidadeSuperioresForm = this.fb.group({
      id: [''],
      idEntidadeSuperior: ['',Validators.required],
      dataAssociacao: ['',],
      dataDesassociacao: [''],
      tipoRelacaoId: ['',Validators.required],
      justificativa: [''],
      dataCadastro: [''],
    });

    this.entidadeForm.get('tipoEntidadeId')?.valueChanges.subscribe(() => {
      this.reset();
    });

    this.tipoRelacaoIdControl?.valueChanges.subscribe((val: any) => {

      if (!this.tipoRelacaoList || !val) {
        this.isShowDataAssociacao = false;
        return;
      }

      if (!this.editar && !this.desvincular) {
        this.entidadeSuperioresForm.get('idEntidadeSuperior')?.reset();
        this.filtrarEntidadesSuperiores();
      }

      const tipoRelacao = this.tipoRelacaoList.find((tipo: any) => tipo?.id === val?.id);
      console.log('Tipo de relação selecionada:', tipoRelacao);
      this.idTipoRelacaoEntidadeSelecionada = val?.id;
      this.isOrganizacao = tipoRelacao?.nomeTipoRelacao === TipoRelacao.Organizacao;
      this.isShowDataAssociacao = !this.isOrganizacao;
      if(tipoRelacao?.nomeTipoRelacao === TipoRelacao.Associacao){
        this.isShowDataAssociacao = true;
        this.entidadeSuperioresForm.get('dataAssociacao')?.setValidators([Validators.required]);
      } else if(tipoRelacao?.nomeTipoRelacao === 'TIPO RELACA'){
        this.isShowDataAssociacao = false;
        this.entidadeSuperioresForm.get('dataAssociacao')?.removeValidators([Validators.required]);
      }
      console.log('tipoRelacao:', tipoRelacao);
    });
  }

  submit() {
    // Captura do valor do formulário
    const objForm = { ...this.entidadeSuperioresForm.getRawValue() };
    console.log('Objeto do formulário antes de qualquer modificação:', objForm);

    // Atribuição do id da entidade
    objForm.entidadeId = this.idParams;
    console.log('Objeto após adicionar o id da entidade:', objForm);

    if (!objForm.tipoRelacaoId || extrairId(objForm.idEntidadeSuperior) == null) {
        this.entidadeSuperioresForm.markAllAsTouched();
        this.messageService.error('Selecione uma entidade e um tipo de relação');
        return;
    }

    // Verificação da dataAssociacao quando tipoRelacaoId é igual a 2
    if(objForm.tipoRelacaoId.id == 2 && (objForm.dataAssociacao === null || objForm.dataAssociacao === undefined || objForm.dataAssociacao === '')) {
        this.dataAssociacaoInvalida = true;
        console.log('Data de associação inválida para tipo de relação 2:', objForm.dataAssociacao);
        return;
    }

    // Se não for para mostrar a data de associação, remove o campo
    if(!this.isShowDataAssociacao) {
        delete objForm.dataAssociacao;
        console.log('Após deletar a dataAssociacao:', objForm);
    }

    // Switch para tratar as ações de desassociar, editar ou salvar
    switch (true) {
        case this.desvincular:
            console.log('Ação: Desassociar');
            this.deleteEntidadesSuperior(objForm);
            break;
        case this.editar:
            console.log('Ação: Editar');
            this.editarEntidadesSuperior(objForm);
            break;
        default:
            console.log('Ação: Salvar, antes de salvar:', objForm);
            this.salvarEntidadesSuperior(objForm);
            break;
    }
}

isEdicao(): boolean {
  return !!this.idParams;
}

  salvarEntidadesSuperior(objEnvio: any) {
    if (objEnvio.entidadeId) {
      const payload = normalizarEntidadeSuperiorParaApi({
        ...objEnvio,
        entidadeId: objEnvio.entidadeId,
        justificativa: objEnvio.justificativa || null,
      });

      this.entidadesService.salvarEntidadesSuperior(payload).subscribe(() => {
        this.messageService.success('Entidade Superior salva com sucesso!');
        this.carregarTabela();
      });
    } else {
      objEnvio.dataCadastro = dayjs().toISOString();
      objEnvio.dataAssociacao = paraIsoOuNull(objEnvio.dataAssociacao);
      objEnvio.dataDesassociacao = paraIsoOuNull(objEnvio.dataDesassociacao);
      const lista = [
        ...(this.entidadeSuperiorListFiltrado || []),
        ...(this.entidadeSuperiorList || []),
      ];
      const snapshot = snapshotEntidadeSuperior(lista, objEnvio.idEntidadeSuperior);
      if (snapshot) {
        objEnvio.idEntidadeSuperior = snapshot;
        objEnvio.nome = snapshot.nome;
        objEnvio.nomeReduzido = snapshot.nomeReduzido;
        objEnvio.cnpj = snapshot.cnpj;
      }
      this.dataSet.push(objEnvio);

      this.entidadeSuperioresForm.reset();

      this.enviarEntidadeSuperior();
    }
  }

  editarEntidadesSuperior(objEnvio: any) {
    if (objEnvio.entidadeId) {
      const payload = normalizarEntidadeSuperiorParaApi({
        ...objEnvio,
        entidadeId: objEnvio.entidadeId,
        id: objEnvio.id,
        justificativa: objEnvio.justificativa || null,
      });

      this.entidadesService.editarEntidadesSuperior(payload).subscribe(() => {
        this.messageService.success('Entidade Superior editada com sucesso!');
        this.carregarTabela();
      });
    } else {
      if (this.indexItemAtual !== undefined) {
        objEnvio.dataAssociacao = paraIsoOuNull(objEnvio.dataAssociacao);
        objEnvio.dataDesassociacao = paraIsoOuNull(objEnvio.dataDesassociacao);
        this.dataSet[this.indexItemAtual] = objEnvio;
        this.indexItemAtual = undefined;
      }
      this.enviarEntidadeSuperior();
    }
  }

  deleteEntidadesSuperior(objEnvio: any) {
    const payload = normalizarEntidadeSuperiorParaApi({
      ...objEnvio,
      entidadeId: objEnvio.entidadeId,
      id: objEnvio.id,
      justificativa: objEnvio.justificativa || null,
    });

    this.entidadesService.deleteEntidadesSuperior(payload).subscribe(() => {
      this.messageService.success('Entidade Superior desassociada com sucesso!');
      this.carregarTabela();
    });
  }

  carregarTabela() {
    if (this.idParams) {
      this.entidadesService.consultarEntidadesSuperior(this.idParams, this.paginator.pagination).subscribe(entidadesSuperiores => {
        this.dataSet = entidadesSuperiores.content;
        this.paginator.totalItens = entidadesSuperiores.totalElements;
        this.entidadeForm.get('entidadeSuperiores')?.setValue(this.dataSet);

        this.reset();
      });
    }
  }

  editarItem(item: any, index?: number) {
    this.editar = true;
    this.desvincular = false;
    this.vincular = false;
    this.isShowDataAssociacao = true;
    this.isShowDataDesassociacao = true;

    if (this.idParams) {
      item.entidadeSuperiorIds = { id: item?.idEntidadeSuperior };
      item.tipoRelacaoId = { id: item?.tipoRelacao?.id, nomeTipoRelacao: item?.tipoRelacao?.nomeTipoRelacao };
    }

    this.dataAssociacaoControl?.enable();
    this.dataDesassociacaoControl?.enable();
    this.idEntidadeSuperiorControl?.disable();
    this.indexItemAtual = index;

    this.entidadeSuperioresForm.patchValue(item);
    this.entidadeSuperiorListFiltrado = this.entidadeSuperiorList;
    console.log(item)
  }

  desassociarItem(item: any) {
    console.log(item);
    this.desvincular = true;
    this.editar = false;
    this.isShowDataAssociacao = false;
    this.isShowDataDesassociacao = true;

    if (this.idParams) {
      item.entidadeSuperiorIds = { id: item.idEntidadeSuperior };
      item.tipoRelacaoId = item?.tipoRelacao?.id;
    }

    this.entidadeSuperioresForm.patchValue(item);

    this.idEntidadeSuperiorControl?.disable();
    this.dataAssociacaoControl?.disable();
  }

  removerItem(item: any) {
    if (!item.id) {
      const index: number = this.dataSet.findIndex(i => i === item);
      if (index !== -1) {
        this.dataSet.splice(index, 1);
      }
      this.enviarEntidadeSuperior();
    }
  }

  reset() {
    this.entidadeSuperioresForm.reset();
    this.idEntidadeSuperiorControl?.enable();
    this.isShowDataAssociacao = false;
    this.isShowDataDesassociacao = false;
    this.editar = false;
    this.desvincular = false;
  }

  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    const sortField = itemSelected?.key;
    const sortOrder = itemSelected?.value;

    const sortParams = {
      sortField,
      sortOrder
    };

    if(sortField && sortOrder) {
      this.loadData(sortParams);
    }
  }

  loadData(sortParams?: any): void {
    let params = {};
    if (sortParams) {
      params = { ...sortParams };
    }

    this.entidadesService.consultarSortEntidadesSuperior(this.idParams, this.paginator.pagination, params).subscribe((data) => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    }
    if(a?.id === undefined && b?.id) {
      return a === b.id;
    }

    else if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    }
    else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    }
    else {
      return a === b;
    }
  }

  filtrarEntidadesSuperiores() {
      const tipoRelacao = this.tipoRelacaoIdControl?.value;

      this.entidadeSuperiorListFiltrado = this.entidadeSuperiorList.filter((entidadeSuperior: any) => {
        const ehRepresentacaoNacional = entidadeSuperior.representacaoId === 1;
        const ehFederacao = entidadeSuperior.idEntidade === TipoEntidadeEnum.Federacao;
        const ehConfederacao = entidadeSuperior.idEntidade === TipoEntidadeEnum.Confederacao;
        const ehOrgaoOuArea = entidadeSuperior.idEntidade === TipoEntidadeEnum.Orgao || entidadeSuperior.idEntidade === TipoEntidadeEnum.Area;

        switch (tipoRelacao.nomeTipoRelacao) {
          case TipoRelacao.Associacao: {
            return ehFederacao && ehRepresentacaoNacional;
          }
          case TipoRelacao.Representacao: {
            return (ehFederacao || ehConfederacao) && ehRepresentacaoNacional;
          }
          case TipoRelacao.Organizacao: {
            // Representantes do Mercado Segurador Nacional + Órgãos + Áreas (SINCORs sem representação nacional ficam de fora)
            return ehRepresentacaoNacional || ehOrgaoOuArea;
          }
          default: {
            return false;
          }
        }
    })
  }

  enviarEntidadeSuperior() {
    this.cdr.detectChanges();
    this.entidadeForm.get('entidadeSuperiores')?.setValue(this.dataSet);
    if (this.paginator) {
      this.paginator.totalItens = this.dataSet.length;
    }
  }

  nomeReduzidoLinha(item: any): string {
    return nomeReduzidoSuperiorLinha(item);
  }

  nomeLinha(item: any): string {
    return nomeSuperiorLinha(item);
  }

  cnpjLinha(item: any): string {
    return cnpjSuperiorLinha(item);
  }

  tipoRelacaoLinha(item: any): string {
    return nomeTipoRelacaoLinha(item);
  }

  onTipoRelacaoEntidadeChange(value: any) {
    if (this.tipoRelacaoList) {
      const tipoRelacao = this.tipoRelacaoList.find((tipo: any) => tipo?.id === value?.id);
      this.idTipoRelacaoEntidadeSelecionada = value?.id;
      this.isOrganizacao = tipoRelacao?.nomeTipoRelacao === TipoRelacao.Organizacao;

      if (this.isOrganizacao) {
        this.isShowDataAssociacao = false;
        // this.isShowDataAssociacao = false;
      } else if(tipoRelacao?.nomeTipoRelacao === TipoRelacao.Associacao){
        this.isShowDataAssociacao = true;
      }else if(tipoRelacao?.nomeTipoRelacao === 'TIPO RELACAO'){
        this.isShowDataAssociacao = true;
      }
      // else {
      //   this.isShowDataAssociacao = true;
      // }
    }
  }

  textoBotao(): string {
    switch (true) {
      case this.desvincular:
        return 'Desvincular';
      case this.editar:
        return 'Editar';
      default:
        return 'Vincular';
    }
  }

  esconderBotaoItemDesassociado(item: any): boolean {
    return item.id && item.status != 'Desvinculada';
  }

  esconderBotaoRemover(item: any): boolean {
    return !item.id;
  }

  onInputDateChange(inputValue: any, campo: string): void {
    dataComDigitacao(inputValue, this.entidadeSuperioresForm, campo);
  }

  get idEntidadeSuperiorControl() {
    return this.entidadeSuperioresForm.get('idEntidadeSuperior');
  }

  get dataAssociacaoControl() {
    return this.entidadeSuperioresForm.get('dataAssociacao');
  }

  get dataDesassociacaoControl() {
    return this.entidadeSuperioresForm.get('dataDesassociacao');
  }

  get tipoRelacaoIdControl() {
    return this.entidadeSuperioresForm.get('tipoRelacaoId');
  }

   // Método para marcar o campo como touched
   onBlur(controlName: string): void {
    const control = this.entidadeSuperioresForm.get(controlName);
    if (control) {
      control.markAsTouched();
    }
  }

  // Método opcional para lidar com mudanças e marcar como dirty
  onChange(controlName: string): void {
    const control = this.entidadeSuperioresForm.get(controlName);
    if (control) {
      control.markAsDirty();
      control.updateValueAndValidity();
      // control.markAsPending()
    }
  }
}
